import { Component, OnInit, Renderer2 } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Component({
  selector: 'app-struttura',
  templateUrl: './struttura.component.html',
  styleUrl: './struttura.component.css'
})
export class StrutturaComponent implements OnInit {

  constructor(private router: Router, private renderer: Renderer2) { }

  carica: boolean = true;
  private lastPath = '';

  ngOnInit(): void {

    // Faccio aspettare mezzo secondo e rimuovo il caricamento
    setTimeout(() => {
      this.carica = false;
    }, 500);

    // Ogni volta che viene cambiato la route (non sui soli #hash, es. abbecedario)
    this.router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe((event) => {
      const path = event.urlAfterRedirects.split('#')[0];
      const fragmentOnly = path === this.lastPath && event.urlAfterRedirects.includes('#');
      this.lastPath = path;
      if (fragmentOnly) return;

      this.carica = true;
      setTimeout(() => {
        this.carica = false;
      }, 500);
    });

  }

}
